import { useMutation } from "@apollo/client/react";


















































export const useDataClientMutation = useMutation;
